export const REGEXP = /\{\s*([\w-]+)\s*\}/g;
export const ZH_CN = 'zh-cn';
export const EN_US = 'en';
export const LANG = 'lang';
export const LANG_LIST = [ZH_CN, EN_US];

export type Lang = (typeof LANG_LIST)[number];
